import React from 'react'
import colors from '../../branding/colors'
import PropTypes from 'prop-types'

OnfsHeader.propTypes = {
  label: PropTypes.string.isRequired,
  level: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6']),
  size: PropTypes.oneOf(['xxs', 'xs', 'sm', 'md', 'lg', 'xl'])
}

export default function OnfsHeader({
  level = 'h1',
  label = '',
  size = 'lg',
  style,
  ...rest
}) {
  let sizeStyle = {
    fontFamily: "'Open Sans', sansSerif",
    fontWeight: '700',
    color: colors.primary,
    width: '100%',
    lineHeight: '1.1',
    ...style
  }

  switch (size) {
    case 'xxs':
      sizeStyle = { ...sizeStyle, fontSize: '1.125rem' }
      break
    case 'xs':
      sizeStyle = { ...sizeStyle, fontSize: '1.25rem' }
      break
    case 'sm':
      sizeStyle = { ...sizeStyle, fontSize: '1.75rem' }
      break
    case 'md':
      sizeStyle = { ...sizeStyle, fontSize: '2rem' }
      break
    case 'lg':
      sizeStyle = { ...sizeStyle, fontSize: '2.5rem' }
      break
    case 'xl':
      sizeStyle = { ...sizeStyle, fontSize: '3rem' }
      break
    default:
      break
  }

  let heading

  if (level.toLowerCase() === 'h1') {
    heading = (
      <h1 style={sizeStyle} {...rest}>
        {label}
      </h1>
    )
  } else if (level.toLowerCase() === 'h2') {
    heading = (
      <h2 style={sizeStyle} {...rest}>
        {label}
      </h2>
    )
  } else if (level.toLowerCase() === 'h3') {
    heading = (
      <h3 style={sizeStyle} {...rest}>
        {label}
      </h3>
    )
  } else if (level.toLowerCase() === 'h4') {
    heading = (
      <h4 style={sizeStyle} {...rest}>
        {label}
      </h4>
    )
  } else if (level.toLowerCase() === 'h5') {
    heading = (
      <h5 style={sizeStyle} {...rest}>
        {label}
      </h5>
    )
  } else if (level.toLowerCase() === 'h6') {
    heading = (
      <h6 style={sizeStyle} {...rest}>
        {label}
      </h6>
    )
  }

  return heading
}
